export default () => ({
  deviceList: [],
});